<template>
  <div id="other-author-confirm"
       class="flex-center">
    <div class="ipub-block ipub-shadow">
      <div class="ipub-h3 mar-b-20 tips flex">
        <ipub-icon style="font-size:30px"
                   class="warning-color"
                   type="iconDetails" />
        <font class="mar-l-12">Warning! You must submit this page to vertify your contribution to the submission.</font>
      </div>
      <div class="mar-b-30 ipub-p2">Please respond to the questions/statements below and click on the "Submit to Publication" button to complete your Co-Author verification for the submission. If you do not submit your responses, your contribution will not be confirmed.</div>
      <div class="question-list mar-b-30">
        <div v-for="item in questionList"
             class="mar-b-50"
             :key="item.questionId">
          <div class="ipub-p1 mar-b-10">
            <font v-if="item.required"
                  class="key-color">*</font>{{item.questionContent}}
          </div>
          <div v-if="item.type === 'QA'">
            <ipub-input v-model.trim="item.answer"
                        style="width: 800px"
                        placeholder="Input your answer" />
          </div>
          <div v-else-if="item.type === 'SINGLE'">
            <ipub-select v-model="item.checkedOption"
                         placeholder="Select your answer"
                         style="width: 400px">
              <ipub-select-option v-for="(val, num) in JSON.parse(item.questionOption)"
                                  :value="num"
                                  :key="val.answer + num">
                {{val.answer}}
              </ipub-select-option>
            </ipub-select>
            <div v-if="(item.checkedOption || item.checkedOption===0) && JSON.parse(item.questionOption)[item.checkedOption].supplementary"
                 style="margin-top: 10px">
              <div class="ipub-p2 mar-b-10">
                {{JSON.parse(item.questionOption)[item.checkedOption].supplementary}}
              </div>
              <div>
                <ipub-input v-model.trim="item.supplyAnswer"
                            style="width: 800px"
                            placeholder="Input your answer" />
              </div>
            </div>
          </div>
          <div v-else-if="item.type === 'MULTIPLE'">
            <ipub-select v-model="item.checkedOptions"
                         placeholder="Select your answers"
                         mode="multiple"
                         optionKey="answer"
                         optionTitle="answer"
                         style="width: 400px"
                         :options="JSON.parse(item.questionOption)" />
          </div>
        </div>
      </div>
      <ipub-button type="primary"
                   @click="submit">
        Submit to Publication
      </ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
